module.exports = __webpack_public_path__ + "img/menu-dixingtu-active.2086417d.svg";